export const SETUP_FIELDS_SET_CURRENT_OBJECT = 'SETUP_FIELDS_SET_CURRENT_OBJECT';

/* table view action */
export const SETUP_FIELDS_SET_OTHER_OBJECT_FILEDS = 'SETUP_FIELDS_SET_OTHER_OBJECT_FILEDS';
export const SETUP_FIELDS_SELECT_FIELD = 'SETUP_FIELDS_SELECT_FIELD';
export const SETUP_FIELDS_CHANGE_MAPPING_FIELD_STATUS = 'SETUP_FIELDS_CHANGE_MAPPING_FIELD_STATUS';

export const SETUP_FIELDS_TOGGLE_EDITING = 'SETUP_FIELDS_TOGGLE_EDITING';

/* add field */
export const SETUP_FIELDS_SET_FIELD_ATTR = 'SETUP_FIELDS_SET_FIELD_ATTR';
export const SETUP_FIELDS_RESET_ADDED_ATTR = 'SETUP_FIELDS_RESET_ADDED_ATTR';
export const SETUP_FIELDS_SET_ADDED_ATTR = 'SETUP_FIELDS_SET_ADDED_ATTR';
export const SETUP_FIELDS_SET_OBJECT_LAYOUT = 'SETUP_FIELDS_SET_OBJECT_LAYOUT';
export const SETUP_FIELDS_SET_FIELD_LABEL_IS_DUPLICATE = 'SETUP_FIELDS_SET_FIELD_LABEL_IS_DUPLICATE';
export const SETUP_FIELDS_DELETE_PICKLIST_VALUE = 'SETUP_FIELDS_DELETE_PICKLIST_VALUE';
export const SETUP_FIELDS_ADD_PICKLIST_VALUE = 'SETUP_FIELDS_ADD_PICKLIST_VALUE';
export const SET_DEFAULT_PICKLIST = 'SET_DEFAULT_PICKLIST';
export const SET_ADD_FIELD_PICKLIST_VALUE = 'SET_ADD_FIELD_PICKLIST_VALUE';

/* picklist value team restriction */
export const SETUP_FIELDS_PICKLIST_VALUE_MANAGEMENT = 'SETUP_FIELDS_PICKLIST_VALUE_MANAGEMENT';
export const SETUP_FIELDS_PICKLIST_VALUE_TOGGLE_ADDING = 'SETUP_FIELDS_PICKLIST_VALUE_TOGGLE_ADDING';
export const SETUP_FIELDS_PICKLIST_ADD_RESTRICT_DEPARTMENT_USER = 'SETUP_FIELDS_PICKLIST_ADD_RESTRICT_DEPARTMENT_USER';
/* replace Dialog */

export const SETUP_FIELDS_SET_REPLACE_DIALOG_ATTR = 'SETUP_FIELDS_SET_REPLACE_DIALOG_ATTR';

// restriction
export const SET_RESTRICTION_TEAMS = 'SET_RESTRICTION_TEAMS';



// WEBPACK FOOTER //
// ./src/views/Setup/Fields/flow/actionType.js